<template>
  <v-dialog-old ref="dialog" id="passportDetailsDialog" @hidden="resetComponentData()" :onCloseEsc="onclose">
      <PassportCancelDialog ref="passportCancelDialog" @canceled="updated" />
    <fieldset style="width:100%">
      <legend>Анкета</legend>

      <table class="grid">
        <tr valign="top">
          <td rowspan="5" width="150" valign="top">
            <img class="avatar"
                 :src="M.img ? storagePublicUrl + '/images/doctors/150x225/' + M.img : ''"
                 style="width:150px; height:225px; cursor:pointer; background-size: contain;"
                 :style="{'background-image': 'url(/_assets/pic_he.svg)'}"
            />

            <a class="button small"
               :href="'https://doctu.ru/' + M.cityCharId + '/doctor/' + M.doctu_url"
               v-tooltip="'https://doctu.ru<br/>/' + M.cityCharId + '/doctor/' + M.doctu_url"
               target="_blank"
               width="150"
            >
              <i class="fa fa-link"></i>
              Показать на сайте
            </a>
          </td>
          <td colspan="3">
            <label>Фамилия</label>
            <input class="large" type="text" v-model="M.fullname" readonly />
          </td>
        </tr>
        <tr>
          <td colspan="3">

              <div v-if="M.doctorDocuments && M.doctorDocuments.length" class="doctor_documents">
                  <label>Диплом</label>

                  <span class="comma">
                        <a :href="'/storage.secure/' +filename" v-for="filename in M.doctorDocuments" target="_blank">
                            <i class="fa fa-user" v-if="filename.includes('/photo/')"></i>
                            <i class="fa fa-file" v-else></i>&nbsp;{{ filename.replace(/^.*[\\\/]/, '') }}
                        </a>
                    </span>
<!--                  <photo-gallery-->
<!--                      id="doctor_documents"-->
<!--                      v-model="M.doctorDocuments"-->
<!--                      :imagesBasePath="'/storage.secure/'"-->

<!--                      style="padding-left: 7%; width: 459px;  overflow: auto;"-->
<!--                      :previewMode="true"-->
<!--                      :is-moderation="true"-->
<!--                      :include-full-size="false"-->
<!--                  ></photo-gallery>-->

              </div>

          </td>
        </tr>

      </table>
    </fieldset>

    <fieldset>
      <legend>Паспорт</legend>
      <table class="grid">
        <tr>
          <td colspan="5" valign="top">
            <label>ФИО</label>
            <input class="large" type="text" v-model="M.name"/>
          </td>
        </tr>
        <tr>
          <td valign="top">
            <label>Дата рождения</label>
            <input type="date" v-model="M.birthday"/>
          </td>
          <td valign="top">
            <label>Серия</label>
            <input type="text" v-model="M.series"/>
          </td>
          <td valign="top">
            <label>Номер</label>
            <input type="text" v-model="M.number"/>
          </td>
          <td valign="top">
            <label>Код подразделения</label>
            <input type="text" v-model="M.department_code"/>
          </td>
          <td valign="top">
            <label>Дата выдачи</label>
            <input type="date" v-model="M.issue_at"/>
          </td>
        </tr>
        <tr>
          <td colspan="5" valign="top">
            <label>Выдан</label>
            <input type="text" v-model="M.department_name"/>
          </td>
        </tr>
      </table>
        <div v-if="M.passportDocuments && M.passportDocuments.length" class="passport_documents">
            <hr style="margin: 5px 0 5px 0"/>

            <label>Документы:</label>

            <photo-gallery
                id="passport_documents"
                v-model="M.passportDocuments"
                :imagesBasePath="'/storage.secure/doctors_docs/' + M.doctor_user_id + '/passport_details_photo/'"
                style="min-width: 459px;  overflow: auto;"
                :previewMode="true"
                :is-moderation="true"
                :include-full-size="false"
                :openImagesInNewTab="true"
            ></photo-gallery>

        </div>
    </fieldset>


      <footer>
          <v-loading-component @click="confirm" v-if="M.status === 'NEW'">
              <template slot-scope="{ loadingClass }">
                  <button :class="['green', loadingClass]" >Подтвердить</button>
              </template>
          </v-loading-component>


          <v-loading-component @click="cancel" v-if="M.status === 'NEW'">
              <template slot-scope="{ loadingClass }">
                    <button :class="['red', loadingClass]">Отказать</button>
              </template>
          </v-loading-component>
      </footer>
  </v-dialog-old>
</template>
<script>
import PhotoGallery from "@common/PhotoGallery";
import PassportCancelDialog from './PassportCancelDialog'
import {STORAGE_PUBLIC} from "@global/const";

export default {
    components:{
        PhotoGallery,
        PassportCancelDialog
    },
    data(){
        return{
          M: {
            id: '',
            doctor_user_id: '',
            name: '',
            img:'',
            birthday: '',
            series: '',
            number: '',
            department_code: '',
            issue_at: '',
            department_name: '',
            fullname: '',
            doctu_url: '',
            cityCharId: '',
            status: '',
            passportDocuments: [],
            doctorDocuments: []


          }
        }
    },
  methods: {
    resetComponentData(){
        this.M.passportDocuments = []
        this.M.doctorDocuments = []
    },
    show(id) {


        return this.axios.post('passportDetails/read/' + id).then(response => {
            Object.assign(this.M, response.data);
            if(response.data.photo_front){this.M.passportDocuments.push(response.data.photo_front)}
            if(response.data.photo_register){this.M.passportDocuments.push(response.data.photo_register)}
            if(response.data.photo_name_change){this.M.passportDocuments.push(response.data.photo_name_change)}

            this.$refs.dialog.show()
        });

    },
    confirm(){

        this.axios.post('passportDetails/confirm/' + this.M.id, this.M).then(() => {
            this.resetComponentData()
            this.$refs.dialog.hide();
            this.$emit('updated');
        })
    },
    updated() {
        this.resetComponentData()
        this.$refs.dialog.hide();
        this.$emit('updated');
    },
      cancel() {
          this.$refs.passportCancelDialog.show({
              passportDetailsId: this.M.id,
          });
      },
      onclose() {
          this.resetComponentData()
          this.$refs.dialog.hide();
      },

  },
    computed: {
        storagePublicUrl() {
            return STORAGE_PUBLIC;
        },
    }
}
</script>

<style>
#passportDetailsDialog {
  width: 950px;
}
</style>
